
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.864 12.523a6.803 6.803 0 00-3.352-2.936 4.191 4.191 0 10-5.03 0 6.803 6.803 0 00-3.351 2.936.661.661 0 101.145.661c1-1.727 2.764-2.757 4.721-2.757 1.957 0 3.722 1.03 4.721 2.757a.662.662 0 001.146-.661zM5.13 6.236a2.868 2.868 0 115.735 0 2.868 2.868 0 01-5.735 0z"}})])
          )
        }
      }
    